<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header pointer" (click)="expandOrCollapse()">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        @if (!assessorId) {
            <h3>Tax Rates</h3>
        }
        @if (assessorId) {
            <h3>Tax Rate Areas</h3>
        }
        @if (showBody) {
            <div class="float-end header-button-container" (click)="$event.stopPropagation()">
                <!-- <ag-grid-filter-toggle [gridApi]="gridApi"></ag-grid-filter-toggle> -->
                @if (!isMaximized) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="toggleMaximize(true)">
                        <i class="fa fa-arrows-alt" title="Expand"></i>
                    </button>
                }
                @if (isMaximized) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="toggleMaximize(false)">
                        <i class="fa fa-compress" title="Collapse"></i>
                    </button>
                }
            </div>
        }
    </div>
    @if (showBody) {
        <div class="panel-flat-body d-flex flex-column" [ngClass]="{'tax-rates-maximized': isMaximized}">
            <div class="d-flex justify-content-around mb-2">
                @if (!assessorId) {
                    <div class="d-flex align-items-center tax-rates-form-items">
                        <label class="ws-flex-auto mb-0">Show:</label>
                        <div class="radio m-0">
                            <label>
                                <input type="radio"
                                       name="taxAuthorityOrRateAreaRadioButton"
                                       value="authorities"
                                       [(ngModel)]="selectedGridSourceOption"
                                       (ngModelChange)="selectedGridSourceChanged('authorities')"> Tax Authorities
                            </label>
                        </div>
                        <div class="radio m-0">
                            <label>
                                <input type="radio"
                                       name="taxAuthorityOrRateAreaRadioButton"
                                       value="areas"
                                       [(ngModel)]="selectedGridSourceOption"
                                       (ngModelChange)="selectedGridSourceChanged('areas')"> Tax Rate Areas
                            </label>
                        </div>
                    </div>
                }
                <show-tax-year [(taxYearBegin)]="taxRatesPanelService.taxYearBegin" [(taxYearsPrior)]="taxRatesPanelService.taxYearsPrior" (showTaxYearChanged)="showTaxYearChanged()"></show-tax-year>
            </div>
            <div class="tax-rates-grid">
                <ws-ag-grid-angular [gridId]="gridId"
                                    [gridOptions]="gridOptions"
                                    (gridReady)="onAgGridReady($event)">
                </ws-ag-grid-angular>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-2">
                @if (hasTaxRatePermission) {
                    <div>
                        @if (selectedGridSourceOption === 'areas') {
                            <button type="button" class="ace-btn btn-sm btn-primary" (click)="addTaxRateArea()">Add New
                                Tax Rate Area
                            </button>
                        }
                        @if (selectedGridSourceOption === 'authorities') {
                            <button type="button" class="ace-btn btn-sm btn-primary" (click)="addTaxAuthority()">Add New
                                Tax Authority
                            </button>
                        }
                    </div>
                }
                @if (hasTaxRatePermission) {
                    <div>
                        <a class="pointer" (click)="navigateToCommandCenter()">Tax Rate Command Center</a>
                    </div>
                }
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="showDisabled" (ngModelChange)="showDisabledChanged()"> Show
                        Disabled
                    </label>
                </div>
            </div>
        </div>
    }
</div>
